import { render, staticRenderFns } from "./AdministrationHome.vue?vue&type=template&id=1475b8bb&scoped=true&"
import script from "./AdministrationHome.vue?vue&type=script&lang=js&"
export * from "./AdministrationHome.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationHome.vue?vue&type=style&index=0&id=1475b8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475b8bb",
  null
  
)

export default component.exports